module.exports = __webpack_public_path__ + "static/media/FormatoSimplificado_307286.d1ea3620.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/ift/InternetInRecargas/FormatoSimplificado_307286.pdf
// module id = 826
// module chunks = 0